import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18next from 'i18next'

import Wopi360App from '../Wopi360App'
import Loading from '../Loading'
import Wopi360Questionnaire from '../Wopi360Questionnaire'

import {
  resetWopi360Questionnaire,
  fetchWopi360Questionnaire,
  fetchTranslationsForWopi360Questions,
  answerWopi360Questions,
  answerWopi360OpenQuestions,
  startWopi360Questionnaire,
  selectWopi360QuestionnaireRole
} from '../../ducks/wopi360-questionnaire'
import { tryGetCurrentAccount } from '../../ducks/account'
import withPreventNavigation from '../hocs/withPreventNavigation'

class Wopi360QuestionnaireContainer extends Component {
  componentDidMount() {
    const {
      tryGetCurrentAccount,
      resetWopi360Questionnaire,
      fetchWopi360Questionnaire
    } = this.props

    tryGetCurrentAccount()
    resetWopi360Questionnaire()
    fetchWopi360Questionnaire(this.props.routeParams.uuid)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language && nextProps.language !== this.props.language) {
      this.props.fetchTranslationsForWopi360Questions(nextProps.language)
    }
  }

  handleLanguageChange = language => {
    this.props.fetchTranslationsForWopi360Questions(language)
  }

  handleAnswer = answers => {
    const { answerWopi360Questions, uuid, questions, activeQuestionIndex } = this.props

    answerWopi360Questions(uuid, questions, activeQuestionIndex, answers)
  }

  handleOpenAnswer = openAnswers => {
    const { answerWopi360OpenQuestions, uuid } = this.props

    answerWopi360OpenQuestions(uuid, openAnswers)
  }

  handleStart = () => {
    const { startWopi360Questionnaire, uuid } = this.props

    startWopi360Questionnaire(uuid)
  }

  handleSelectRole = role => {
    const { selectWopi360QuestionnaireRole, uuid } = this.props

    selectWopi360QuestionnaireRole(uuid, role)
  }

  render() {
    const {
      isLoading,
      isTranslationReady,
      questions,
      openQuestions,
      role,
      language,
      target,
      isTarget,
      activeQuestionIndex,
      activeQuestionAnswer,
      isStarted,
      currentAccount
    } = this.props

    const renderPhase = () => {
      if (!isLoading && questions.isEmpty()) {
        return (
          <div style={{ textAlign: 'center' }}>
            <h1>{i18next.t('questionnaire_not_found', { lng: language, ns: 'questionnaire' })}</h1>
          </div>
        )
      }

      if (!isLoading && target && target.isClosed) {
        return (
          <div style={{ textAlign: 'center' }}>
            <h1>{i18next.t('questionnaire_closed', { lng: language, ns: 'questionnaire' })}</h1>
          </div>
        )
      }

      return (
        <Wopi360Questionnaire
          target={target}
          isTarget={isTarget}
          language={language}
          onStart={this.handleStart}
          onSelectRole={this.handleSelectRole}
          questions={questions}
          openQuestions={openQuestions}
          role={role}
          activeQuestionIndex={activeQuestionIndex}
          activeQuestionAnswer={activeQuestionAnswer}
          onAnswer={this.handleAnswer}
          onOpenAnswer={this.handleOpenAnswer}
          isStarted={isStarted}
          refreshQuestionnaire={() =>
            this.props.fetchWopi360Questionnaire(this.props.routeParams.uuid)
          }
        />
      )
    }

    return (
      <Loading isReady={!isLoading && isTranslationReady}>
        <Wopi360App
          currentAccount={currentAccount}
          currentLanguage={language}
          hideNonAdminLanguages={false}
          onChangeLanguage={this.handleLanguageChange}
          targetName={isStarted ? `${target.givenName} ${target.familyName}` : ''}
          hideLanguageSwitcher={isStarted}
        >
          {renderPhase()}
        </Wopi360App>
      </Loading>
    )
  }
}

export default connect(
  state => ({
    isStarted: state.wopi360Questionnaire.get('isStarted'),
    isLoading: state.wopi360Questionnaire.get('isLoading'),
    isTranslationReady: state.wopi360Questionnaire.get('isTranslationReady'),
    questions: state.wopi360Questionnaire.get('questions'),
    openQuestions: state.wopi360Questionnaire.get('openQuestions'),
    role: state.wopi360Questionnaire.get('role'),
    target: state.wopi360Questionnaire.get('target'),
    isTarget: state.wopi360Questionnaire.get('isTarget'),
    activeQuestionIndex: state.wopi360Questionnaire.get('activeQuestionIndex'),
    activeQuestionAnswer: state.wopi360Questionnaire.get('activeQuestionAnswer'),
    language: state.wopi360Questionnaire.get('language'),
    uuid: state.wopi360Questionnaire.get('uuid'),
    currentAccount: state.account.get('currentAccount'),
    isFinished: state.wopi360Questionnaire.get('isFinished')
  }),
  {
    resetWopi360Questionnaire,
    fetchWopi360Questionnaire,
    fetchTranslationsForWopi360Questions,
    answerWopi360Questions,
    answerWopi360OpenQuestions,
    startWopi360Questionnaire,
    selectWopi360QuestionnaireRole,
    tryGetCurrentAccount
  }
)(withPreventNavigation(Wopi360QuestionnaireContainer))



// WEBPACK FOOTER //
// ./src/components/smart/Wopi360QuestionnaireContainer.js